require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-robin-apparicio.json") })
        }
      }, "path---blog-author-robin-apparicio");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-robin-apparicio!./.cache/json/blog-author-robin-apparicio.json
// module id = 699
// module chunks = 231608221292675